<div class="credito-compact flex flex-col w-full h-full bg-gray-100 p-2 sm:p-3 min-h-0 text-xs sm:text-sm">
  <div class="bg-white rounded-lg shadow-md p-3 sm:p-4 max-h-[calc(100vh-8rem)] flex flex-col min-h-0 overflow-hidden">
    <!-- Cabeçalho fixo no topo do painel: título, cliente, remover, fechar venda -->
    <div class="sticky top-0 z-10 flex flex-wrap items-center gap-1.5 gap-y-1.5 bg-white pb-2 mb-2 border-b border-gray-200 -mx-1 px-1 -mt-1 pt-0 shrink-0">
      <h2 class="text-lg sm:text-xl font-bold text-gray-800 m-0 shrink-0 leading-tight">Crediário</h2>
      <ng-container *ngIf="creditoData.cliente">
        <span class="text-xs sm:text-sm text-gray-800 font-medium truncate max-w-[10rem] sm:max-w-md md:max-w-xl leading-tight"
              [attr.title]="creditoData.cliente.fullName">
          {{ creditoData.cliente.fullName }}
        </span>
        <button
          type="button"
          (click)="removerCliente()"
          class="shrink-0 inline-flex items-center justify-center w-6 h-6 rounded border border-gray-300 bg-white text-xs text-gray-600 hover:bg-red-50 hover:text-red-700 hover:border-red-300 focus:outline-none focus:ring-1 focus:ring-red-400"
          title="Remover cliente"
          aria-label="Remover cliente selecionado">
          <span class="text-base leading-none font-semibold" aria-hidden="true">×</span>
        </button>
        <button
          (click)="confirmarCredito()"
          [disabled]="creditoData.parcelas.length === 0"
          pButton
          type="button"
          label="Fechar Venda (F7)"
          class="p-button-danger p-button-sm w-full sm:w-auto sm:ml-auto basis-full sm:basis-auto">
        </button>
      </ng-container>
    </div>

    <div class="flex flex-col flex-1 min-h-0 gap-0">
      <!-- Área com scroll: sem datepicker (overflow cortaria o painel do calendário) -->
      <div class="flex-1 min-h-0 overflow-y-auto overflow-x-hidden">
        <div class="bg-gray-50 p-2 sm:p-3 rounded-md rounded-b-none">
          <div *ngIf="!creditoData.cliente" class="mb-2 p-2 bg-yellow-50 border border-yellow-200 rounded-md">
            <p class="text-xs text-yellow-800 leading-snug">Nenhum cliente selecionado. Selecione um cliente na coluna esquerda.</p>
          </div>

          <div class="grid grid-cols-2 gap-2 sm:gap-3">
            <div>
              <label class="block text-xs font-medium text-gray-600 mb-0.5 leading-tight">Receita</label>
              <div class="w-full px-2 py-1 bg-gray-100 border border-gray-300 rounded-md text-xs leading-snug">
                {{ creditoData.receita }}
              </div>
            </div>

            <div>
              <label class="block text-xs font-medium text-gray-600 mb-0.5 leading-tight">Valor Total</label>
              <div class="w-full px-2 py-1 bg-gray-100 border border-gray-300 rounded-md text-xs font-semibold text-green-600 leading-snug">
                {{ creditoData.valorTotal | currency:'BRL' }}
              </div>
            </div>

            <div>
              <label class="block text-xs font-medium text-gray-600 mb-0.5 leading-tight">Valor de entrada</label>
              <p-inputNumber
                [(ngModel)]="creditoData.valorEntrada"
                (onInput)="onValorEntradaChange()"
                [min]="0"
                [max]="creditoData.valorTotal"
                mode="decimal"
                [minFractionDigits]="2"
                [maxFractionDigits]="2"
                size="small"
                class="w-full"
                [style]="{'width': '100%'}">
              </p-inputNumber>
            </div>

            <div>
              <label class="block text-xs font-medium text-gray-600 mb-0.5 leading-tight">Nº de Parcelas</label>
              <p-inputNumber
                #numeroParcelasInput
                [(ngModel)]="creditoData.numeroParcelas"
                (onInput)="onNumeroParcelasChange()"
                [min]="1"
                [max]="999"
                size="small"
                class="w-full"
                [style]="{'width': '100%'}"
                inputId="numero-parcelas-input">
              </p-inputNumber>
            </div>
          </div>
        </div>
      </div>

      <!-- Fora do scroll: calendário posiciona o overlay ao lado do campo -->
      <div class="shrink-0 bg-gray-50 px-2 sm:px-3 py-2 border-t border-gray-200 relative z-20">
        <div class="grid grid-cols-2 gap-2 sm:gap-3">
          <div>
            <label class="block text-xs font-medium text-gray-600 mb-0.5 leading-tight">1º Vencimento</label>
            <p-calendar
              [(ngModel)]="primeiroVencimentoDate"
              (onSelect)="onPrimeiroVencimentoChange()"
              dateFormat="dd/mm/yy"
              showIcon="true"
              [showButtonBar]="true"
              inputId="credito-primeiro-vencimento"
              [inputStyle]="calendarInputStyle"
              class="w-full"
              [style]="{'width': '100%'}">
            </p-calendar>
          </div>

          <div>
            <label class="block text-xs font-medium text-gray-600 mb-0.5 leading-tight">Intervalo (dias)</label>
            <p-inputNumber
              [(ngModel)]="creditoData.intervalo"
              (onInput)="onIntervaloChange()"
              [min]="1"
              [max]="365"
              size="small"
              class="w-full"
              [style]="{'width': '100%'}">
            </p-inputNumber>
          </div>
        </div>
      </div>

      <div class="flex-1 min-h-0 overflow-y-auto bg-gray-50 px-2 sm:px-3 pb-2 sm:pb-3 rounded-b-md">
        <div class="mt-1">
          <label class="block text-xs font-medium text-gray-600 mb-1 leading-tight">Parcelas:</label>
          <div class="h-44 sm:h-52 max-h-[40vh] overflow-y-auto border border-gray-300 rounded-md bg-white">
            <div *ngFor="let parcela of creditoData.parcelas"
                 class="py-1 px-2 border-b border-gray-100 last:border-b-0 text-xs leading-snug">
              <div class="flex justify-between gap-1">
                <span><strong>Parcela {{ parcela.numero }}:</strong></span>
                <span><strong>{{ parcela.vencimento }}</strong></span>
                <span class="font-semibold text-green-600 shrink-0">{{ parcela.valor | currency:'BRL' }}</span>
              </div>
            </div>
            <div *ngIf="creditoData.parcelas.length === 0" class="p-2 text-center text-gray-500 text-xs leading-snug">
              Configure o número de parcelas, primeiro vencimento e intervalo para visualizar as parcelas.
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="flex justify-end shrink-0 pt-2 mt-auto border-t border-gray-100">
      <button
        (click)="voltar()"
        pButton
        type="button"
        label="ESC - Voltar"
        class="p-button-secondary p-button-sm">
      </button>
    </div>
  </div>
</div>

<!-- Modal de Cadastro de Cliente -->
<p-dialog
  header="Cadastrar Novo Cliente"
  [(visible)]="showCadastroCliente"
  [modal]="true"
  [style]="{width: '500px'}"
  [closable]="true">
  <div class="flex flex-col gap-4">
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-1">Nome Completo <span class="text-red-500">*</span></label>
      <input
        [(ngModel)]="novoCliente.fullName"
        pInputText
        class="w-full"
        placeholder="Digite o nome completo">
    </div>

    <div>
      <label class="block text-sm font-medium text-gray-700 mb-1">CPF/CNPJ</label>
      <input
        [(ngModel)]="novoCliente.cpf"
        pInputText
        class="w-full"
        placeholder="Digite o CPF ou CNPJ">
    </div>

    <div>
      <label class="block text-sm font-medium text-gray-700 mb-1">Telefone</label>
      <input
        [(ngModel)]="novoCliente.phone"
        pInputText
        class="w-full"
        placeholder="Digite o telefone">
    </div>

    <div class="flex justify-end gap-2 mt-4">
      <button
        (click)="fecharCadastroCliente()"
        pButton
        type="button"
        label="Cancelar"
        class="p-button-secondary">
      </button>
      <button
        (click)="salvarNovoCliente()"
        pButton
        type="button"
        label="Salvar"
        class="p-button-primary">
      </button>
    </div>
  </div>
</p-dialog>
